module.exports = __webpack_public_path__ + "static/img/8.f0b8166.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/8.png
// module id = ZPCD
// module chunks = 0